query GetDataUploadRows($dataUploadId: ID!) {
  dataUploadRows(dataUploadId: $dataUploadId) {
    id
    rowIndex
    raw
    parsed
    validationErrors
    dupSuggestions
    decision
    newRecordId
    newRecordType
    status
    importErrors
    createdAt
    updatedAt
  }
}
